<template>
  <div class="product-content-fi">
    <headline-fi
      v-if="isLG"
      class="product-content-fi__headline"
      tag="div"
      :size="21"
    >
      {{ $dict.get('product-List.Table.Attribute-Content') }}
    </headline-fi>

    <grid-container-fi :container="false">
      <div class="product-content-fi__table-container">
        <technical-details-table-fi
          :item="item"
          :attributes="attributes"
        />
      </div>

      <div
        v-if="productLineDrawing"
        class="product-content-fi__media-container"
      >
        <cloud-image-fi
          :src="productLineDrawing"
          class="product-content-fi__image"
          alt=""
          width="400"
          do-not-replace-url
        />
      </div>
    </grid-container-fi>
  </div>
</template>

<script>
import { CloudImageFi, HeadlineFi } from 'atoms';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import TechnicalDetailsTableFi from 'components/shop-modules/technical-details-table-fi/TechnicalDetailsTableFi';
import breakpointMixin from 'mixins/breakpointMixin';

export default {
  name: 'ProductContentFi',
  components: {
    HeadlineFi,
    CloudImageFi,
    GridContainerFi,
    TechnicalDetailsTableFi,
  },
  mixins: [breakpointMixin],
  inject: ['fields'],
  props: {
    item: {
      type: Object,
      default: null,
    },
    attributes: {
      type: Array,
      required: true,
    },
    familyLineDrawing: {
      type: [String, null],
      default: null,
    },
    bestPrice: {
      type: Object,
      default: null,
    },
  },
  computed: {
    productLineDrawing() {
      return this.item?.catalogProductData?.productLineDrawing || this.familyLineDrawing;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './product-content-fi';
</style>
